<span class="title">{{ label }}</span>
<span class="value">{{ value | absoluteNumber }}</span>
